/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Faq_A4Inputs */

const en_to_yaml_faq_a4 = /** @type {(inputs: To_Yaml_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not with this tool directly. PureJSON focuses on JSON-to-YAML conversion. However, since YAML is a superset of JSON, you can use a YAML parser to convert back.`)
};

const ko_to_yaml_faq_a4 = /** @type {(inputs: To_Yaml_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 도구에서는 직접 지원하지 않습니다. PureJSON은 JSON에서 YAML로의 변환에 중점을 둡니다. 다만 YAML은 JSON의 상위 집합이므로 YAML 파서를 사용하여 역변환할 수 있습니다.`)
};

const ja_to_yaml_faq_a4 = /** @type {(inputs: To_Yaml_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このツールでは直接できません。PureJSONはJSON→YAML変換に特化しています。ただし、YAMLはJSONのスーパーセットなので、YAMLパーサーを使用して逆変換できます。`)
};

/**
* | output |
* | --- |
* | "Not with this tool directly. PureJSON focuses on JSON-to-YAML conversion. However, since YAML is a superset of JSON, you can use a YAML parser to convert back." |
*
* @param {To_Yaml_Faq_A4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_faq_a4 = /** @type {((inputs?: To_Yaml_Faq_A4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Faq_A4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_faq_a4(inputs)
	if (locale === "ko") return ko_to_yaml_faq_a4(inputs)
	return ja_to_yaml_faq_a4(inputs)
});